"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_HellsRetribution_OnEffectAppliedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Ability_HellsRetribution_OnEffectAppliedEventHandlerScript = class Ability_HellsRetribution_OnEffectAppliedEventHandlerScript {
    run(sequence, container, handler, event) {
        const effect = container.getEffect(event.args.effectId);
        switch (effect === null || effect === void 0 ? void 0 : effect.args.__typeName) {
            case "Fear":
                break;
            case "Stun":
                break;
            case "Slow":
                break;
            default:
                return;
        }
        container.applyProjectiles({
            sequence,
            onProjectile: (sequence, projectile) => {
                container.applyDebuffs({
                    attackerId: event.subject,
                    targetId: projectile.targetId,
                    effects: [
                        {
                            duration: effect.duration.type !== enums_1.DurationType.Permanent ? effect.duration
                                : Duration_1.Duration.Turns(2),
                            effect: effect.args
                        }
                    ],
                    sequence
                });
            },
            projectiles: container.selectLivingTargets(effect.creatorId, Target_1.Target.AllAllies)
                .map(targetId => ({
                creatorId: event.subject,
                targetId,
                path: "line",
                jitter: 0,
                type: "PurpleEvilComet",
            }))
        });
    }
};
Ability_HellsRetribution_OnEffectAppliedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_HellsRetribution_OnEffectApplied")
], Ability_HellsRetribution_OnEffectAppliedEventHandlerScript);
exports.Ability_HellsRetribution_OnEffectAppliedEventHandlerScript = Ability_HellsRetribution_OnEffectAppliedEventHandlerScript;
